import {
    AfterContentInit,
    ChangeDetectorRef,
    Component,
    ContentChildren,
    EventEmitter,
    HostBinding,
    Input,
    OnChanges,
    Output,
    QueryList,
    SimpleChanges,
    ViewEncapsulation,
} from "@angular/core";
import { tickDelay } from "@spscommerce/utils";

import { CardSpsTab } from "../../types/card";
import { SpsCardTabbedPaneComponent } from "../card-tabbed-pane/sps-card-tabbed-pane.component";

@Component({
    selector: "sps-card",
    templateUrl: "./sps-card.component.html",
    encapsulation: ViewEncapsulation.Emulated
})
export class SpsCardComponent implements AfterContentInit, OnChanges {
    static readonly displayName = "sps-card";
    static readonly props = {
        activeTab: "string",
        tabChange: { event: true, type: "CardSpsTab" },
    };

    @Input() activeTab: string;
    @Input() id;

    @Output() tabChange = new EventEmitter<CardSpsTab>();

    @HostBinding("class.sps-card") readonly _classSpsCard = true;

    @ContentChildren(SpsCardTabbedPaneComponent) panes: QueryList<SpsCardTabbedPaneComponent>;

    tabs: CardSpsTab[] = [];
    _activeSpsTab: CardSpsTab;

    constructor(private changeDetector: ChangeDetectorRef) {}

    _onTabChange(newTab: CardSpsTab) {
        for (const tab of this.tabs) {
            if (tab === newTab) {
                this._activeSpsTab = tab;
                this.activeTab = tab.controlsId;
                tab.activate();
            } else {
                tab.deactivate();
            }
        }
        this.tabChange.emit(newTab);
    }

    @tickDelay
    private _updateActiveTab() {
        if (this.tabs && this.tabs.length) {
            this._activeSpsTab = null;
            for (const tab of this.tabs) {
                if (tab.controlsId === this.activeTab) {
                    this._activeSpsTab = tab;
                    tab.activate();
                } else {
                    tab.deactivate();
                }
            }

            if (!this._activeSpsTab) {
                this.activeTab = this.tabs[0].controlsId;
                this._activeSpsTab = this.tabs[0];
                this._activeSpsTab.activate();
            }
        }
    }

    @tickDelay
    private _registerTabs() {
        this.tabs = (this.panes as any).map((pane: SpsCardTabbedPaneComponent): CardSpsTab => ({
            label: pane.label,
            id: pane.tabId,
            controlsId: pane.id,
            icon: pane.icon,
            tag: pane.tag,
            activate: pane.activate,
            deactivate: pane.deactivate
        }));
        this.changeDetector.markForCheck();
        this._updateActiveTab();
    }

    ngAfterContentInit() {
        if (this.panes) {
            this._registerTabs();
            this.panes.changes.subscribe(this._registerTabs);
        }
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.activeTab) {
            this._updateActiveTab();
        }
    }
}
